<script setup>
import Fields from './Fields.vue'
import { useStore } from '@admin_js/store'
import Button from '@admin_ui/Components/Common/Elements/Button'

const emits = defineEmits(['filter'])
const store = useStore()

const filter = () => {
  emits('filter')
}
</script>

<template>
  <Transition>
    <div
      v-show="store.show_filters"
      class="my-8 flex items-center justify-between"
    >
      <div class="flex items-center space-x-6">
        <Fields />
      </div>
      <Button class="self-end" @click="filter()">Filter</Button>
    </div>
  </Transition>
</template>

<style>
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
</style>
